import { render, staticRenderFns } from "./BikyConfig.vue?vue&type=template&id=784a929a&scoped=true&"
import script from "./BikyConfig.vue?vue&type=script&lang=ts&"
export * from "./BikyConfig.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfig.vue?vue&type=style&index=0&id=784a929a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a929a",
  null
  
)

export default component.exports